import { useForm } from 'react-hook-form'
import { Button, Col, Form, Row } from 'react-bootstrap'
import InputWrapper from 'shared/components/InputWrapper'
import resAddFilterValue from './resolvers/resAddFilterValue'
import useFocusError from 'shared/hooks/useFocusError'
import React from 'react'
import prepareSubmitForm from './utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import SelectWrapper from 'shared/components/SelectWrapper'
import { filterValuesTypes } from 'consts'
import useInit from './hooks/useInit'

interface AddFilterValueFormProps {
  filterId: string
  isMulti: boolean
  setShowOverlay: Function
  setButtonClickCount: Function
}

const AddFilterValueForm: React.FunctionComponent<AddFilterValueFormProps> = (
  props: AddFilterValueFormProps,
) => {
  const submitRef = React.createRef<HTMLButtonElement>()

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resAddFilterValue,
  })

  useInit({
    setValue
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Form
      onSubmit={handleSubmit((data) =>
        prepareSubmitForm({
          submitForm,
          setValue,
          setButtonClickCount: props.setButtonClickCount,
          data,
          reset,
          setShowOverlay: props.setShowOverlay,
          setError,
          id: props.filterId,
          name: 'Filter Value',
        }),
      )}
      id='main-form'
    >
      <Row>
        <Col xs='12' md='2'>
          <InputWrapper label='Type' name='type' errors={errors} colAttributes={{ md: 12 }}>
            <SelectWrapper
              name='type'
              control={control}
              options={props.isMulti ? filterValuesTypes.filter(f => f.id === null) : filterValuesTypes}
              optionLabel='name'
              optionValue='id'
              isClearable={false}
              placeholder='Select Type...'
            />
          </InputWrapper>
        </Col>

        <Col xs='12' md='3'>
          <InputWrapper colAttributes={{ md: 12 }} label='Label' name='label' errors={errors}>
            <Form.Control type='text' {...register('label')} />
          </InputWrapper>
        </Col>

        <Col xs='12' md='3'>
          <InputWrapper colAttributes={{ md: 12 }} label='Value' name='value' errors={errors}>
            <Form.Control type='text' {...register('value')} />
          </InputWrapper>
        </Col>
        <Col xs='12' md='3'>
          <InputWrapper
            colAttributes={{ md: 12 }}
            label='Parent Value'
            name='parent_value'
            errors={errors}
          >
            <Form.Control type='text' {...register('parent_value')} />
          </InputWrapper>
        </Col>

        <Col xs='12' md='1' className='pt-0 pt-md-4 mb-3'>
          <Button type='submit' name='save' className='btn-round '>
            Add
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default AddFilterValueForm
